
export const UNIVERSAL_FORM_MODEL = 'universal-form-model'; // model object of entire universal form
export const FORM_BUILDER = 'form-builder'; // to register editor to parent meta-editors form group
export const FORCE_SETTINGS = 'force-settings'; // to pass local settings to editors
export const EDITORS_LOCALIZE = 'editors-localize'; // pass custom localize function
export const ERRORS_LOCALIZE = 'errors-localize'; // pass custom localize function